import { Link } from "react-router";
import { useI18n } from "../i18n/I18nProvider";
import { useAsync } from "../lib/useAsync";
import { marketApi } from "./api";
import { Avatar, Stars } from "./components";

/** Shops whose @handle or name match the global search; nothing at all (not even a loader) when none do. */
export function SellerMatches({ q }: { q: string }) {
  const { t } = useI18n();
  const text = q.trim();
  const sellers = useAsync((signal) => (text.replace(/^@+/, "").length >= 2 ? marketApi.searchSellers(text, signal) : Promise.resolve([])), [text]);
  if (!sellers.data?.length) return null;
  return (
    <section className="seller-matches" aria-labelledby="seller-matches-title">
      <h2 id="seller-matches-title" className="seller-matches-title">
        {t("search.sellers")}
      </h2>
      <ul>
        {sellers.data.map((s) => (
          <li key={s.handle}>
            <Link to={`/vendedores/${s.handle}`} className="seller-match">
              <Avatar url={s.avatarUrl} name={s.displayName} size={40} />
              <span>
                <strong>{s.displayName}</strong>
                <span className="muted small">
                  @{s.handle}
                  {s.city ? ` · ${s.city}` : ""}
                </span>
                <span className="muted small">
                  <Stars value={s.ratingAvg} count={s.ratingCount} size="sm" /> · {t("search.sellerListings", { count: s.listings })}
                  {s.verified && <span className="seller-verified"> · 🪪 {t("mkt.verified")}</span>}
                </span>
              </span>
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
}
